import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BannerDetails } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrl: './header-v2.component.scss'
})

export class HeaderV2Component implements OnInit {
 
  @ViewChild('mobileMenu') mobileMenu!: TemplateRef<any>;
 
  public isInformationOpen = false;
  public isAccountMenuOpen = true;
  public bannersDetails: BannerDetails[] = [];
  public logoUrl: string = '';
 
  constructor(
    private configService: ConfigService,
    private offcanvasService: NgbOffcanvas,
    public authManager: AuthManagerService,
    private userService: UserService,
  ) {
    this.logoUrl = this.configService.get('logo');
  }

  ngOnInit(): void {
    this.userService.getBannersDetails().subscribe({
      next: (details: BannerDetails[]) => {
        this.bannersDetails = details;
      },
      error: (error) => {
        console.error('Error fetching banner details', error);
      }
    });
  }

  get userEmail(): string | undefined {
    return this.userService.user?.contact?.email;
  }

  get isAnyBannerEnabled(): boolean {
    return this.bannersDetails.some(banner => banner.isEnabled);
  }
 
  openMenu(content: TemplateRef<any>): void {
    this.isInformationOpen = false;
    this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'app-navbar__offcanvas'
    });
  }
 
  toggleInformation(): void {
    this.isInformationOpen = !this.isInformationOpen;
  }

  toggleAccountMenu(): void {
    this.isAccountMenuOpen = !this.isAccountMenuOpen;
  }
}
